// React Native polyfills
import 'react-native-get-random-values';

import { v4 as uuidv4 } from 'uuid';

export default function generateUniqueId() {
  return uuidv4();
}
